export default __webpack_public_path__ + "static/media/UploadIcon.469126df.svg";